@if (compareSelected === SelectedCompare.PocketDepth) {
  <div
    class="absolute z-20 grid h-full w-full gap-x-1 gap-y-[6%] bg-transparent px-4"
    [ngClass]="{ 'pl-8 pr-0': selectedQuadrant !== null }"
    [style.gridTemplateColumns]="selectedQuadrant === null ? 'repeat(2, minmax(0, 1fr))' : 'repeat(1, minmax(0, 1fr))'"
    [style.gridTemplateRows]="selectedQuadrant === null ? 'repeat(2, minmax(0, 1fr))' : 'repeat(1, minmax(0, 1fr))'"
    @fadeInOut
  >
    @if (selectedQuadrant !== null) {
      <!-- SELECTED-QUADRANT -->
      <div
        class="grid"
        [class]="selectedQuadrant.includes('top') ? 'grid-rows-[40%_auto_37%]' : 'grid-rows-[34%_auto_42%]'"
        @fadeInOnlyDelayed
      >
        <!-- UPPER OVERLAY -->
        <div class="row-start-1 h-28 self-end">
          <lib-pocket-depth-table
            [currentTeeth]="currentSelectedQuadrantTeeth"
            [previousTeeth]="previousSelectedQuadrantTeeth"
            [isQuadrantSelected]="true"
            [overlayPosition]="selectedQuadrant"
            [toothSide]="selectedQuadrant.includes('top') ? 'buccal' : 'lingual'"
          ></lib-pocket-depth-table>
        </div>

        <!-- LOWER OVERLAY -->
        <div class="row-start-3 h-28 self-start">
          <lib-pocket-depth-table
            [currentTeeth]="currentSelectedQuadrantTeeth"
            [previousTeeth]="previousSelectedQuadrantTeeth"
            [isQuadrantSelected]="true"
            [overlayPosition]="selectedQuadrant"
            [toothSide]="selectedQuadrant.includes('bottom') ? 'buccal' : 'lingual'"
          ></lib-pocket-depth-table>
        </div>
      </div>
    }

    @if (selectedQuadrant === null) {
      <!-- TOP-RIGHT-QUADRANT -->
      <div class="grid grid-rows-[45%_auto_30%]" @fadeInOnly>
        <!-- BUCCAL -->
        <div class="row-start-1 self-end">
          <lib-pocket-depth-table
            [currentTeeth]="currentTopRightTeeth"
            [previousTeeth]="previousTopRightTeeth"
            [overlayPosition]="Quadrant.TopRight"
            toothSide="buccal"
          ></lib-pocket-depth-table>
        </div>

        <!-- LINGUAL -->
        <div class="row-start-3 self-start">
          <lib-pocket-depth-table
            [currentTeeth]="currentTopRightTeeth"
            [previousTeeth]="previousTopRightTeeth"
            [overlayPosition]="Quadrant.TopRight"
            toothSide="lingual"
          ></lib-pocket-depth-table>
        </div>
      </div>
      <!-- TOP-LEFT-QUADRANT -->
      <div class="grid grid-rows-[45%_auto_30%]" @fadeInOnly>
        <!-- BUCCAL -->
        <div class="row-start-1 self-end">
          <lib-pocket-depth-table
            [currentTeeth]="currentTopLeftTeeth"
            [previousTeeth]="previousTopLeftTeeth"
            [overlayPosition]="Quadrant.TopLeft"
            toothSide="buccal"
          ></lib-pocket-depth-table>
        </div>

        <!-- LINGUAL -->
        <div class="row-start-3 self-start">
          <lib-pocket-depth-table
            [currentTeeth]="currentTopLeftTeeth"
            [previousTeeth]="previousTopLeftTeeth"
            [overlayPosition]="Quadrant.TopLeft"
            toothSide="lingual"
          ></lib-pocket-depth-table>
        </div>
      </div>

      <!-- BOTTOM-RIGHT-QUADRANT -->
      <div class="grid grid-rows-[30%_auto_45%]" @fadeInOnly>
        <!--  LINGUAL -->
        <div class="row-start-1 self-end">
          <lib-pocket-depth-table
            [currentTeeth]="currentBottomRightTeeth"
            [previousTeeth]="previousBottomRightTeeth"
            [overlayPosition]="Quadrant.BottomRight"
            toothSide="lingual"
          ></lib-pocket-depth-table>
        </div>

        <!-- BUCCAL -->
        <div class="row-start-3 self-start">
          <lib-pocket-depth-table
            [currentTeeth]="currentBottomRightTeeth"
            [previousTeeth]="previousBottomRightTeeth"
            [overlayPosition]="Quadrant.BottomRight"
            toothSide="buccal"
          ></lib-pocket-depth-table>
        </div>
      </div>

      <!-- BOTTOM-LEFT-QUADRANT -->
      <div class="grid grid-rows-[30%_auto_45%]" @fadeInOnly>
        <!--  LINGUAL -->
        <div class="row-start-1 self-end">
          <lib-pocket-depth-table
            [currentTeeth]="currentBottomLeftTeeth"
            [previousTeeth]="previousBottomLeftTeeth"
            [overlayPosition]="Quadrant.BottomLeft"
            toothSide="lingual"
          ></lib-pocket-depth-table>
        </div>

        <!-- BUCCAL -->
        <div class="row-start-3 self-start">
          <lib-pocket-depth-table
            [currentTeeth]="currentBottomLeftTeeth"
            [previousTeeth]="previousBottomLeftTeeth"
            [overlayPosition]="Quadrant.BottomLeft"
            toothSide="buccal"
          ></lib-pocket-depth-table>
        </div>
      </div>
    }
  </div>
}
